import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import * as takeRight from 'lodash/takeRight';
import { filter } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class UrlHistoryService {
	public history: string[] = [];

	public get historyWithCurrentUrl(): string[] {
		return [...this.history, this.router.url];
	}

	constructor(
		private router: Router
	) {
		this.history.push(this.router.url); // push current url
		this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(({ urlAfterRedirects }: NavigationEnd) => {
			this.history = takeRight([...this.history, urlAfterRedirects], 5);
		});
	}

	public isQueryParamUpdated(queryParam: string, includeCurrentUrl: boolean = true): boolean {
		const queryParamCheck = `${queryParam}=`;
		const history = includeCurrentUrl ? this.historyWithCurrentUrl : this.history;

		if (history.length > 1) {
			const isQueryParamAdded = history[history.length - 1].includes(queryParamCheck) && !history[history.length - 2].includes(queryParamCheck);
			const isQueryParamRemoved = !history[history.length - 1].includes(queryParamCheck) && history[history.length - 2].includes(queryParamCheck);

			const lastQueryParam = this.getQueryParamValue(history[history.length - 1], queryParam);
			const secondLastQueryParam = this.getQueryParamValue(history[history.length - 2], queryParam);
			const isQueryParamUpdated = lastQueryParam && secondLastQueryParam && lastQueryParam !== secondLastQueryParam;

			const isQueryParamChanged = isQueryParamAdded || isQueryParamRemoved || isQueryParamUpdated;
			return isQueryParamChanged;
		}

		return false;
	}

	private getQueryParamValue(url: string, queryParam: string): string {
		if (url && queryParam) {
			const matches = url.match(new RegExp(`${queryParam}=(.+?)(&|$)`));
			return matches?.[1];
		}

		return '';
	}

}
